import React, { useEffect } from "react";
import { IStudentDashboard } from "../../../../models/dashboard/studentDashboard";
import { greetings } from "../../../../common-functions/commonFunctions";
import BetaFreshman from "./components/betaFreshman";
import BetaAcademicProfile from "./components/betaAcademicProfile";
import BetaStudentCourseDetails from "./components/betaStudentCourseDetails";
import BetaStudentAccount from "./components/betaStudentAccount";
import BetaStudentGradeDetails from "./components/betaStudentGradeDetails";
import BetaStudentApps from "./components/betaStudentApps";
import BetaStudentResourceWidgets from "./components/betaStudentResourceWidgets";
import BetaNextTerm from "./components/betaNextTerm";
import BetaMonthCalendar from "./components/betaMonthCalendar";
import { getSnapShots } from "../../../../action/masters/snapShotActionCreator";
import { connect } from "react-redux";
import { getFreshmanProcessVersion } from "../../../../action/freshman/freshmanProcessActionCreator";

const BetaDashboard = (props: IStudentDashboard) => {
  const { userInfo, getSnapShots, getFreshmanVersion, freshmanProcessVersion } =
    props;

  useEffect(() => {
    getSnapShots();
  }, []);

  useEffect(() => {
    userInfo && getFreshmanVersion();
  }, [userInfo]);

  const shouldRenderFreshman = userInfo?.isFreshman;
  const shouldRenderDashboard =
    !userInfo?.isFreshman || userInfo?.isCourseStarted;

  return (
    <>
      <div className="row mb-3">
        <div className="dash-title col-lg-6">
          <h2 className="mb-2">
            {greetings()}, {userInfo?.displayName}
          </h2>
          <p>
            Access your panel to review Widgets, Apps and Plan your next term.
            Click the details button to access all your resources.
          </p>
        </div>
      </div>

      {shouldRenderFreshman && (
        <div className="row mb-3">
          <div className="col-lg-12 mb-3">
            <BetaFreshman userInfo={userInfo} />
          </div>
        </div>
      )}

      {shouldRenderDashboard && (
        <div className="row studdash-beta">
          <div className="col-lg-8 mb-3">
            <div className="card-wrap">
              <div className="widgets">
                <div className="title">
                  <h2>Student Metrics</h2>
                </div>
                <div className="row">
                  <div className="col-lg-6 mb-3">
                    <BetaAcademicProfile />
                  </div>
                  <div className="col-lg-6 mb-3">
                    <BetaStudentCourseDetails />
                  </div>
                  <div className="col-lg-6 mb-3">
                    <BetaStudentAccount />
                  </div>
                  <div className="col-lg-6 mb-3">
                    <BetaStudentGradeDetails />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4 mb-3">
            <BetaStudentApps />
          </div>
          <div className="col-lg-4">
            <BetaStudentResourceWidgets />
          </div>
          <div className="col-lg-4">
            <BetaNextTerm />
          </div>
          <div className="col-lg-4">
            <BetaMonthCalendar />
          </div>
        </div>
      )}
    </>
  );
};
const mapDispatchToProps = {
  getSnapShots: () => getSnapShots(),
  getFreshmanVersion: () => getFreshmanProcessVersion(),
};

function mapStateToProps(state: any) {
  return {
    userInfo: state.userDetails.userProfileData,
    freshmanProcessVersion: state.freshmanProcess.freshmanProcessVersion,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(BetaDashboard);
